import React from 'react';
import signatureActions from 'js/sign-components/sign-app-client/namespace/signature';
import * as signer from 'js/sign-components/sign-app-client/namespace/signer';
import * as tours from 'js/sign-components/sign-app-client/namespace/tours';
import { createSimpleDataContext } from 'js/sign-components/common/create-simple-data-context';


/**
 * SignAppClient is a subset of NamespacedAppActions.
 * Code in src/js/sign-components should useSignAppClient()
 */
export type SignAppClient = {
  signatures: ReturnType<typeof signatureActions>,
  signer: typeof signer,
  tours: typeof tours,
}

const {
  Provider,
  useContext: useSignAppClient,
} = createSimpleDataContext<SignAppClient>('SignAppClient');
export { useSignAppClient };

type ProviderProps = React.PropsWithChildren<{
  client: SignAppClient;
}>;

export function SignAppClientProvider({ client, children }: ProviderProps) {
  return <Provider value={client}>{children}</Provider>;
}

export const makeSignAppClient = (preloadedTsmGroupKey: string): SignAppClient => {
  return {
    signatures: signatureActions(preloadedTsmGroupKey),
    signer,
    tours,
  };
};
